import { render, staticRenderFns } from "./RiskObjectiveAdd.vue?vue&type=template&id=faa468b4&"
import script from "./RiskObjectiveAdd.vue?vue&type=script&lang=js&"
export * from "./RiskObjectiveAdd.vue?vue&type=script&lang=js&"
import style0 from "./RiskObjectiveAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports